var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid footer", attrs: { id: "footer" } },
    [
      _c("div", { staticClass: "row mt-5" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row mt-5" }, [
            _c(
              "div",
              {
                staticClass: "col-md-4  align-self-center center pt-2 pr-0 pb-3"
              },
              [
                _c("div", { staticClass: "container-fluid" }, [
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-12  align-self-center text-left "
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "h5",
                          {
                            staticClass: "black   text-left pb-0 ",
                            staticStyle: { "line-height": "30px" }
                          },
                          [
                            _vm._v(
                              "\n                  © " +
                                _vm._s(_vm.moment().format("YYYY")) +
                                " Cap. Soc. EUR 81.0"
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "black p-0 m-0",
                                attrs: { to: "/cobrowsing" }
                              },
                              [_vm._v("0")]
                            ),
                            _vm._v("0,00 Int. Vers.\n                  "),
                            _c("br"),
                            _vm._v(
                              " P.IVA 09012690963\n                  REA MI 2062710\n                "
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1"
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1"
              },
              [
                _vm.brand == "CHEBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/chebonus/Privacy.pdf?v=2",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Privacy Policy")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.brand == "HAPPYBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/happybonus/Privacy.pdf?v=2",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Privacy Policy")])]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1"
              },
              [
                _vm.brand == "CHEBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/chebonus/Cookie.pdf",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Cookie Policy")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.brand == "HAPPYBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/happybonus/Cookie.pdf",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Cookie Policy")])]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1"
              },
              [
                _vm.brand == "CHEBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/chebonus/Conditions.pdf?v=2",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Termini di utilizzo")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.brand == "HAPPYBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/happybonus/Conditions.pdf?v=2",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Termini di utilizzo")])]
                    )
                  : _vm._e()
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h5",
      {
        staticClass: "black   text-left pb-0 ",
        staticStyle: { "line-height": "20px" }
      },
      [
        _c("b", { staticClass: "pb-3 widthFull" }, [
          _vm._v("Powered by NOVATAG S.R.L.")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62fe346e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62fe346e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/index.vue
// module id = null
// module chunks = 